exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.loading-overlay[data-v-675af700] {\r\n  font-size: 60px;\r\n  height: 100%;\r\n  width: 100%;\r\n  position: absolute;\r\n  z-index: 1000000;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: white;\r\n  opacity: 80%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\n}\r\n", ""]);

// exports
